import React from 'react';
import block from 'bem-cn-lite';
import {HTML} from '@doc-tools/components';
import {Link, CardBase} from '@yandex-data-ui/page-constructor';

import {ServiceCardProps} from 'units/constructor-local/models';

import {ServiceIcon} from 'components/ServiceIcon';

import './ServiceCard.scss';

const b = block('ServiceCard');

const ServiceCard: React.FC<ServiceCardProps> = (props) => {
    const {title, description, border, services, link} = props;

    return (
        <CardBase className={b()} bodyClassName={b('body')} border={border}>
            <CardBase.Content>
                <h4 className={b('title')}>
                    <HTML>{title}</HTML>
                </h4>
                <div className={b('description')}>
                    <HTML>{description}</HTML>
                </div>
            </CardBase.Content>
            <CardBase.Footer className={b('footer')}>
                <div className={b('links')}>
                    {services &&
                        services.map(({id, name, url}, index) => (
                            <Link key={index} className={b('link')} theme={'normal'} url={url}>
                                <ServiceIcon className={b('link-icon')} name={id} />
                                <span className={b('link-text')}>{name}</span>
                            </Link>
                        ))}
                </div>
                {link && (
                    <Link
                        className={b('link-all')}
                        text={link.text}
                        url={link.url}
                        theme={'normal'}
                        arrow={true}
                    />
                )}
            </CardBase.Footer>
        </CardBase>
    );
};

export default ServiceCard;
